<template>
  <PreviewWrapper class="desktop">
    <div class="header"></div>
    <div class="google-header d-flex">
      <div class="d-flex align-items-center">
        <google />
      </div>
      <div class="">
        <search />
      </div>
    </div>
    <div class="google-menu d-flex border-bottom">
      <span class="active">
        All
      </span>
      <span>
        Images
      </span>
      <span>
        Video
      </span>
      <span>
        News
      </span>
      <span>
        Maps
      </span>
      <span>
        More
      </span>
    </div>
    <!-- <PreviewDetailWrapper> -->
    <div class="google-result">
      <PreviewURL>
        https://{{ domain.main }}/{{ languageUse }}/{{ url }}
      </PreviewURL>
      <PreviewTitle class="text-truncate">
        <span id="previewTitle">
          {{ title ? title.substr(0,60) : 'Page Name, SEO title appears at the top of a browser window' }}{{ title.length > 60 ? '...' : '' }}
        </span>
      </PreviewTitle>
      <PreviewDescription class="text-break">
        <span id="previewDesc">
          {{ description ? description.substr(0,150) : 'The description of a webpage appears when that page is listed in search results.' }}{{ description.length > 150 ? '...' : ''}}
        </span>
      </PreviewDescription>
      <PreviewTitle style="opacity:0;height:0px;margin-bottom:19px;min-width: fit-content;">
        <span class="text-nowrap" id="previewTitlePre">
          {{ title }}
        </span>
      </PreviewTitle>
      <PreviewDescription style="opacity:0;height:0px;min-width: fit-content;">
        <span class="text-nowrap" id="previewDescPre">
          {{ description }}
        </span>
      </PreviewDescription>
      <div class="skeleton" v-for="i in 3" :key="`${i}`">
        <b-skeleton animation="" width="180px" style="background-color:#f8f9fa !important;"></b-skeleton>
        <b-skeleton animation="" width="360px" style="background-color:#ececfe !important;"></b-skeleton>
        <b-skeleton :class="{'last' : i == 3}" animation="" width="600px" height="32px" style="background-color:#f8f9fa !important;"></b-skeleton>
      </div>
    </div>
    <!-- </PreviewDetailWrapper> -->
  </PreviewWrapper>
</template>

<script>
import { mapGetters } from "vuex";
import {
  PreviewWrapper,
  //   PreviewDetailWrapper,
  PreviewURL,
  PreviewTitle,
  PreviewDescription,
} from "./Preview.styled.js";
import google from "./image/google.vue";
import search from "./image/search.vue";
export default {
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      languageUse: "design/site/languageUse",
      domain: "design/page/domain",
    }),
  },
  components: {
    PreviewWrapper,
    // PreviewDetailWrapper,
    PreviewURL,
    PreviewTitle,
    PreviewDescription,
    google,
    search,
  },
  props: {
    url: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    typePage: {
      type:String,
      default : ''
    }
  },
  methods: {
    getWidth() {
      if(this.title) {
        setTimeout(() => {
          this.$emit('setWidth',document.getElementById('previewTitlePre').getBoundingClientRect().width)
        }, 30);
      }else {
        this.$emit('setWidth',0)
      }
    },
    getWidthDesc() {
      if(this.description) {
        setTimeout(() => {
          this.$emit('setWidthDesc',document.getElementById('previewDescPre').getBoundingClientRect().width)
        }, 30);
      }else {
        this.$emit('setWidthDesc',0)
      }
    }
  },
  watch :{
    title() {
      this.getWidth();
    },
    description() {
      this.getWidthDesc();
    },
  },
  mounted(){
    this.getWidth();
    this.getWidthDesc();
  }
};
</script>

<style lang="scss">
.desktop {
  .header {
    height: 16px;
    width: 100%;
    background-color: #f8f9fa;
  }
  .google-header {
    padding: 16px 0px 21px 24px;
    gap: 16px;
  }
  .google-menu {
    gap: 32px;
    font-size: 12px;
    &:not(.active) {
      color: #a5a5a5;
    }
    .active {
      width : 45px;
      text-align: center;
      color: #3971e0;
      position: relative;
      margin-left: 24px;
      &::after {
        content: "";
        height: 2px;
        width: 45px;
        background-color: #3971e0;
        position: absolute;
        top: 17px;
        left: 0;
      }
    }
  }
  .google-result {
    padding: 24px;
    padding-bottom:  0px;
  }
  .skeleton {
    &:not(:last-child) {
      margin-bottom: 16px;
    }
    .b-skeleton {
      &:not(.last) {
        margin-bottom: 8px;
      }
      &.last {
        margin-bottom : 0px;
      }
    }
  }
}
</style>